import React, { Component } from 'react'
import css from './index.scss'

export default class Card extends Component {
  constructor(props) {
    super(props)
    this.state = {
      selected: 0,
    }
  }
  render() {
    if (this.props.onClick) {
      return (
        <div
          className={[css.card, this.props.className].join(' ')}
          onClick={this.props.onClick}
          role="button"
          tabIndex="0"
          style={{ ...this.props.style, cursor: 'pointer' }}
        >
          {this.props.children}
        </div>
      )
    }
    return (
      <div
        className={[css.card, this.props.className].join(' ')}
        style={this.props.style}
      >
        {this.props.children}
      </div>
    )
  }
}
